
import store from '@/store'
import { defineComponent,ref} from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    const route = useRoute()
    const cachedViews = () => {
      return store.getters.cachedViews
    }
    const viewing = ref(['/home'])
    const key = () => {
      return route.path
    }  
    console.log('key',key());
    
    return {
      cachedViews,
      key,
      viewing
    }
  }
})
